module.exports = __webpack_public_path__ + "img/0.e54518b8.jpg";